import { Button, Container, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import Link  from "@material-ui/core/Link";
import ContentList from "../../components/contentList";
import { useDispatch } from "react-redux";
import { setTabPosition } from "../../uiSlice";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  img: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export default function TopupContent() {
  const classes = useStyles();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down("md"));
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const dispatch = useDispatch();
  const LinkText = (props) => {
    const { navIndex, route, text } = props;
    return (
      <Link
        onClick={() => {
          window.scrollTo(0, 0);
          dispatch(setTabPosition(navIndex));
        }}
        component={RouterLink}
        to={route}
        // color="primary"
        className={classes.linktext}
      >
        <b>{text}</b>
      </Link>
    );
  };

  return (
    <Container className={classes.root}>
      <ContentList
        title="QUICK PAY"
        items={[
          "All you need is your account info and your bank card! No need to register... just pay!",
          <Button
            component={RouterLink}
            to="/quickpay"
            color="primary"
            size="large"
            variant="contained"
            onClick={() => {
              window.scrollTo(0, 0);
              dispatch(setTabPosition(7));
            }}
            style={{ borderRadius: 20, marginRight: 10 }}
          >
            Click Here
          </Button>,
        ]}
      />
      <ContentList
        title="ONLINE PAY"
        items={[
          <span>
            Keep track of all your payments and <b>YOOZ It</b> anywhere, anytime
            you want!
          </span>,
          <Button
            component={RouterLink}
            to="/signup"
            color="primary"
            size="large"
            variant="contained"
            onClick={() => {
              window.scrollTo(0, 0);
              dispatch(setTabPosition(8));
            }}
            style={{ borderRadius: 20, marginRight: 10 }}
          >
            Click Here
          </Button>,
        ]}
      />
      <ContentList
        title="MOBILE PAY"
        items={[
          <span>
            <b>No WiFi? No Data? No PROBLEM!</b>{" "}
          </span>,
          <span>Just dial *190# for FREE!</span>,
          <span>
          <LinkText navIndex={6} route="/contact" text="Call or Email us" />{" "}to make an appointment to Register.
                 
        </span>
        ]}
      />
      <ContentList
        title=""
        items={[
          <iframe
            title="billpay info video"
            width={xs ? "100%" : 500}
            height={xs ? 400 : 500}
            src="https://www.youtube.com/embed/-wADKe0OU0o"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>,
        ]}
      />
      <ContentList
        title="YOOZ Scan2Pay"
        items={[
          
          <span>Pay for goods and services with <span style={{color:"#cb010d",fontWeight:"bold"}}>YOOZ Scan2Pay</span>.  It’s FREE and no sign up necessary.  Ask for the <b> YOOZ QR Code</b> or <b>YOOZ URL Link</b> link from your favourite business places to pay the safe, easy and contactless way.</span>,
          
        ]}
      />
       <ContentList
        title=""
        items={[
          <iframe
            title="billpay info video"
            width={xs ? "100%" : 500}
            height={xs ? 400 : 500}
            src="https://www.youtube.com/embed/JJuDwVzxZBE"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>,
        ]}
      />
    </Container>
  );
}
